import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen" data-id="element-49">
      <Header data-id="element-50" />
      <main className="flex-grow" data-id="element-51">{children}</main>
      <Footer data-id="element-52" />
    </div>;
}